module.exports = __webpack_public_path__ + "img/4.24ec6ea0.png";